"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionSelect = void 0;
var React = __importStar(require("react"));
var Box_1 = __importDefault(require("@material-ui/core/Box"));
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var styles_1 = require("@material-ui/core/styles");
var icons_1 = require("@epic-ui/icons");
var InputLabel_1 = __importDefault(require("@material-ui/core/InputLabel"));
var utils_1 = require("@material-ui/utils");
var useStyles = styles_1.makeStyles({
    paper: {
        transform: "translateY(-12px)",
    },
});
exports.OptionSelect = React.forwardRef(function OptionSelect(_a, ref) {
    var _b = _a.label, label = _b === void 0 ? "" : _b, id = _a.id, InputProps = _a.InputProps, InputLabelProps = _a.InputLabelProps, SelectProps = _a.SelectProps, BoxProps = _a.BoxProps, children = _a.children, props = __rest(_a, ["label", "id", "InputProps", "InputLabelProps", "SelectProps", "BoxProps", "children"]);
    var themeProps = styles_1.useTheme().props;
    var classes = useStyles();
    var mergedSelectProps = utils_1.deepmerge(__assign(__assign({}, themeProps === null || themeProps === void 0 ? void 0 : themeProps.MuiSelect), { IconComponent: icons_1.ArrowStrokeDown, MenuProps: {
            classes: classes,
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
            },
            transformOrigin: {
                vertical: "top",
                horizontal: "right",
            },
            getContentAnchorEl: null,
            PaperProps: {
                variant: "outlined",
                style: {},
            },
        } }), SelectProps || {});
    return (React.createElement(Box_1.default, __assign({ display: "flex", alignItems: "center" }, BoxProps),
        React.createElement(InputLabel_1.default, { htmlFor: id }, label),
        React.createElement(TextField_1.default, __assign({ select: true, InputProps: __assign({ disableUnderline: true }, InputProps), SelectProps: mergedSelectProps, variant: "standard", InputLabelProps: __assign({ shrink: false }, InputLabelProps), ref: ref }, props), children)));
});
//# sourceMappingURL=OptionSelect.js.map